import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../../environments/environment';
import {BenefitDTO} from '../models/BenefitDTO';
import {PagedRequestDTO} from '../../common/models/PagedRequestDTO';
import {PagedResponseDTO} from '../../common/models/PagedResponseDTO';

@Injectable({
  providedIn: 'root'
})
export class BenefitService {
  private url = environment.baseUrl + '/benefit';

  constructor(private httpClient: HttpClient) {
  }

  getListOfBenefits(pagedRequestDTO: PagedRequestDTO): Observable<PagedResponseDTO<BenefitDTO>> {
    return this.httpClient.post<PagedResponseDTO<BenefitDTO>>(this.url + '/filter', pagedRequestDTO);
  }

  getBenefitByBenefitId(benefitId: bigint): Observable<BenefitDTO> {
    return this.httpClient.get<BenefitDTO>(`${this.url}/${benefitId}`);
  }

  deleteBenefit(benefitId: bigint) {
    return this.httpClient.delete<{}>(this.url + '/' + benefitId);
  }

  saveBenefit(benefitDTO: BenefitDTO) {
    return this.httpClient.post<BenefitDTO>(`${this.url}`, benefitDTO);
  }
}
